/**
 * The pulse API builds summaryBox as the headline followed by the bullets, so
 * printing both repeated the headline word for word under itself. Show only
 * what the summary adds.
 */
export function summaryWithoutHeadline(summary, headline) {
  const text = String(summary || '').trim();
  const head = String(headline || '').trim();
  if (head && text.startsWith(head)) return text.slice(head.length).trim();
  return text;
}
